import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white,
        marginBottom: 25
    },
    content: {
        marginTop: 18,
        backgroundColor: baseColors.green.light,
        borderRadius: 10
    },
    item: { paddingHorizontal: 18 },
    avatar: { backgroundColor: "grey", borderRadius: 7 },
    divider: { height: 1, backgroundColor: baseColors.green.primary, width: "90%", alignSelf: "center" },
    titleStyle: {
        marginBottom: 10,
        fontSize: 14,
        fontFamily: baseFontFamily.OpenSansRegular,
        color: baseColors.green.primary
    },
    descriptionStyle: {
        fontSize: 14,
        fontFamily: baseFontFamily.OpenSansSemiBold,
        color: baseColors.black
    },
    contactUsTitle: {
        fontSize: 14,
        fontFamily: baseFontFamily.OpenSansSemiBold,
        color: baseColors.black,
        marginTop: -5,
        marginHorizontal: 5
    },
    contactUsItem: { marginVertical: 10 }
})

export default styles
